const prepend = items => (array = []) => [...items, ...array]

export default prepend
